import React from "react";

const Close = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9091 9L16.6781 3.231L17.8678 2.04131C18.0433 1.86581 18.0433 1.58063 17.8678 1.40513L16.5949 0.132188C16.4194 -0.0433124 16.1342 -0.0433124 15.9587 0.132188L9 7.09088L2.04131 0.131625C1.86581 -0.043875 1.58063 -0.043875 1.40513 0.131625L0.131625 1.40456C-0.043875 1.58006 -0.043875 1.86525 0.131625 2.04075L7.09088 9L0.131625 15.9587C-0.043875 16.1342 -0.043875 16.4194 0.131625 16.5949L1.40456 17.8678C1.58006 18.0433 1.86525 18.0433 2.04075 17.8678L9 10.9091L14.769 16.6781L15.9587 17.8678C16.1342 18.0433 16.4194 18.0433 16.5949 17.8678L17.8678 16.5949C18.0433 16.4194 18.0433 16.1342 17.8678 15.9587L10.9091 9Z"
        fill="#343638"
      />
    </svg>
  );
};

export default Close;
